// src/services/useLogsStore.js
import { create } from "zustand";
import { api } from "./api";

export const useLogsStore = create((set, get) => ({
  // State
  logs: [],
  currentLog: null,
  stats: null,
  pagination: {
    total: 0,
    page: 1,
    per_page: 50,
    total_pages: 0,
  },
  filters: {
    type: null,
    user_id: null,
    entity_type: null,
    from: null,
    to: null,
    search: null,
  },
  loading: false,
  error: null,

  // Actions
  fetchLogs: async (filters = {}, page = 1, per_page = 50) => {
    set({ loading: true, error: null });
    try {
      // Build query params
      const params = new URLSearchParams();

      if (filters.type) params.append('type', filters.type);
      if (filters.user_id) params.append('user_id', filters.user_id);
      if (filters.entity_type) params.append('entity_type', filters.entity_type);
      if (filters.from) params.append('from', filters.from);
      if (filters.to) params.append('to', filters.to);
      if (filters.search) params.append('search', filters.search);
      params.append('page', page);
      params.append('per_page', per_page);

      const response = await api.get(`/api/logs?${params.toString()}`);

      set({
        logs: response.data.logs,
        pagination: {
          total: response.data.total,
          page: response.data.page,
          per_page: response.data.per_page,
          total_pages: response.data.total_pages,
        },
        filters,
        loading: false,
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching logs:", error);
      set({
        error: error.response?.data?.error || "Failed to fetch logs",
        loading: false,
      });
      throw error;
    }
  },

  fetchLogById: async (logId) => {
    set({ loading: true, error: null });
    try {
      const response = await api.get(`/api/logs/${logId}`);
      set({ currentLog: response.data, loading: false });
      return response.data;
    } catch (error) {
      console.error("Error fetching log:", error);
      set({
        error: error.response?.data?.error || "Failed to fetch log",
        loading: false,
      });
      throw error;
    }
  },

  fetchStats: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get("/api/logs/stats");
      set({ stats: response.data, loading: false });
      return response.data;
    } catch (error) {
      console.error("Error fetching log stats:", error);
      set({
        error: error.response?.data?.error || "Failed to fetch statistics",
        loading: false,
      });
      throw error;
    }
  },

  setFilters: (newFilters) => {
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    }));
  },

  resetFilters: () => {
    set({
      filters: {
        type: null,
        user_id: null,
        entity_type: null,
        from: null,
        to: null,
        search: null,
      },
    });
  },

  clearError: () => {
    set({ error: null });
  },
}));
